import { useI18n } from '../../i18n/useI18n';

type ChatbotConversationMessagesStatusProps = {
  kind: 'loading' | 'error' | 'empty';
};

export function ChatbotConversationMessagesStatus({
  kind,
}: ChatbotConversationMessagesStatusProps) {
  const { translate } = useI18n();

  if (kind === 'loading') {
    return (
      <p className="chatbot-conversation-detail__status">
        {translate('chatbots.conversations.detail.messagesLoading')}
      </p>
    );
  }

  if (kind === 'error') {
    return (
      <p className="chatbot-conversation-detail__status" role="alert">
        {translate('chatbots.conversations.detail.messagesLoadError')}
      </p>
    );
  }

  return (
    <p className="chatbot-conversation-detail__status">
      {translate('chatbots.conversations.detail.messagesEmpty')}
    </p>
  );
}
